import { api } from '../api/client';
import { translate } from '../i18n/i18n';
import type { ProgramTrack, ProgramView } from './types';

/**
 * Move a program between the two lists, sending only that.
 *
 * <p>The full update would mean posting the program's whole content back to change one thing,
 * so a list loaded before somebody edited it would overwrite their words on a drag.
 */
export async function setTrack(programId: string, track: ProgramTrack): Promise<ProgramView> {
  return api<ProgramView>(`/programs/${programId}/track`, {
    method: 'PATCH',
    token: true,
    body: { track },
  });
}

export const OTHER_TRACK: Record<ProgramTrack, ProgramTrack> = {
  CURRENT: 'MAINTENANCE',
  MAINTENANCE: 'CURRENT',
};

/** What the button says, written as the move rather than as the destination. */
export function moveLabel(track: ProgramTrack): string {
  return track === 'CURRENT' ? translate('Move to maintenance') : translate('Move to current');
}
